import React, { useState, useRef, useEffect } from 'react';
import { TypeAnimation } from 'react-type-animation';
import HALO from 'vanta/dist/vanta.halo.min';
import * as THREE from 'three';
import './home.css';


const Home = ({ scrollToSection }) => {
  const [vantaEffect, setVantaEffect] = useState(null);
  const myRef = useRef(null);

  useEffect(() => {
    if (!vantaEffect) {
      setVantaEffect(
        HALO({
          el: myRef.current,
          mouseControls: true,
          touchControls: true,
          gyroControls: true,
          minHeight: 200.00,
          minWidth: 200.00,
          backgroundColor: 0x000000,
          baseColor: 0x010101, /* Much darker base */
          size: 1.5, /* Slightly smaller for sharpness */
          amplitudeFactor: 1.0, /* Reduced intensity */
          xOffset: 0.1,
          yOffset: 0.1,
          THREE: THREE
        })
      );
    }
    const handleResize = () => {
      if (vantaEffect) {
        vantaEffect.resize();
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      if (vantaEffect) vantaEffect.destroy();
      window.removeEventListener('resize', handleResize);
    };
  }, [vantaEffect]);

  const handleScrollToSection = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };


  return (
    <section id="home" className="full-screen-section" ref={myRef}>
      <header className="App-header">
        <div className="tech-font glitch-header" data-text="HELLO_">
          HELLO
        </div>
        <div className="intro-name">
          I'm <span className="highlight-text">ZhaoSheng</span>
        </div>
        <br />
        <div className="type-animation">
          <TypeAnimation
            sequence={[
              'Site Reliability Engineer',
              1000,
              'DevOps Engineer',
              1000,
              'Web Developer',
              1000,
              'Data Science Graduate',
              1000,
              'Photographer',
              1000
            ]}
            wrapper="span"
            speed={50}
            repeat={Infinity}
            style={{ display: 'inline-block' }}
            className="tech-code"
          />
        </div>
        <br />
        <div className="icons" style={{ display: 'flex', alignItems: 'center' }}>
          <a href="https://www.instagram.com/tongsiusing/" target="_blank" rel="noopener noreferrer" className="icon-padding">
            <img src="/icon/ins-ig.svg" alt="Instagram" style={{ width: '40px', height: '40px' }} />
          </a>
          <a href="https://www.linkedin.com/in/tang-zhaosheng-4408021b7/" target="_blank" rel="noopener noreferrer" className="icon-padding">
            <img src="/icon/linkedin.svg" alt="LinkedIn" style={{ width: '40px', height: '40px' }} />
          </a>
          <a href="ZhaoSheng_resume_2025.pdf" target="_blank" rel="noopener noreferrer" className="resume-button">
            <span>RESUME</span>
          </a>
        </div>
        <div className="scroll_down">
          <div className="scroll-indicator" onClick={handleScrollToSection}>
            <div className="chevron"></div>
            <div className="chevron"></div>
            <div className="chevron"></div>
          </div>
        </div>
      </header>
    </section>
  );
};

export default Home;